module.exports = __webpack_public_path__ + "img/salary-effects.edcb6062.svg";